// element-ui form 组件校验
// 大部分判定允许为空（因为作为查询条件时，可为空）
// 如果不允许为空，在 rules 中添加 required 配置
// 抛出的错误话术为需求提供
import MSG from '../configs/error-message';

// 6-16 位字母和数字
export function validatePass(rule, value, callback) {
  if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(value)) {
    callback();
  } else {
    callback(new Error(MSG.M0005));
  }
}

// 0 -50 位字母或数字
export function validateWorkNo(rule, value, callback) {
  if (/^[\w]{1,50}$/.test(value) || !value) {
    callback();
  } else {
    callback(new Error(MSG.M0001));
  }
}

// 0-50 位字母或汉字
export function validateName(rule, value, callback) {
  if (/^[a-zA-Z\u4e00-\u9fa5]{1,50}$/.test(value) || !value) {
    callback();
  } else {
    callback(new Error(MSG.M0002));
  }
}

// 校验身份证
export function validateIDNo(rule, value, callback) {
  const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
  if (!value || reg.test(value)) {
    callback();
  } else {
    callback(new Error(MSG.M0008));
  }
}

// 校验手机号
export function validatePhone(rule, value, callback) {
  const reg = /^1[0-9]{10}$/;
  if (!value || reg.test(value)) {
    callback();
  } else {
    callback(new Error(MSG.M0009));
  }
}

// 职位
export function validateJobTitle(rule, value, callback) {
  if (/^[\u4e00-\u9fa5a-zA-Z]{1,50}$/.test(value) || !value) {
    callback();
  } else {
    callback(new Error(MSG.M0010));
  }
}

// 邮箱
export function validateEmail(rule, value, callback) {
  if (
    /^([A-Za-z0-9_\-.\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/.test(value)
    || !value
  ) {
    callback();
  } else {
    callback(MSG.M0011);
  }
}
